import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setActiveModule } from '../../redux/reducers/layoutSlice';
import AdminHubLayout from '../../components/admin/AdminHubLayout';
import {
  AddUserIcon,
  Edit05Icon,
  UserGroupIcon,
  UserIcon,
  UsersEditIcon
} from '../../utils/iconSvg';

const USER_SECTIONS = [
  {
    title: 'Create & configure',
    subtitle: 'Add new records or set up access',
    items: [
      {
        menu_name: 'Users',
        title: 'Add User',
        description: 'Register a new user with role and location details.',
        path: '/users/new-user',
        accent: '#3B82F6',
        Icon: AddUserIcon
      },
      {
        menu_name: 'User Groups',
        title: 'User Groups',
        description: 'Create and manage groups for bulk assignments.',
        path: '/user-groups/new-user-group',
        accent: '#8B5CF6',
        Icon: UsersEditIcon
      },
      {
        menu_name: 'Roles and App Access',
        title: 'Roles & Permissions',
        description: 'Define roles and control application access.',
        path: '/roles/new-role',
        accent: '#F59E0B',
        Icon: Edit05Icon
      }
    ]
  },
  {
    title: 'Browse lists',
    subtitle: 'View and manage existing data',
    items: [
      {
        menu_name: 'Users',
        title: 'User list',
        description: 'Search, filter, and manage all platform users.',
        path: '/users/list',
        accent: '#10B981',
        Icon: UserIcon
      },
      {
        menu_name: 'User Groups',
        title: 'User Groups list',
        description: 'See all groups and edit memberships.',
        path: '/user-groups',
        accent: '#EC4899',
        Icon: UserGroupIcon
      },
      {
        menu_name: 'Roles and App Access',
        title: 'Roles & App Access list',
        description: 'Review roles and permission assignments.',
        path: '/roles',
        accent: '#F4C24A',
        Icon: Edit05Icon
      }
    ]
  }
];

function UsersAdminQuickLinks() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleNavigate = menuName => {
    dispatch(setActiveModule(menuName));
  };

  const handleNavigation = (menuName, path) => {
    handleNavigate(menuName);
    navigate(path);
  };

  return (
    <AdminHubLayout
      title="Users"
      subtitle="Manage users, groups, and roles & permissions from the options below."
      sections={USER_SECTIONS}
      onNavigate={handleNavigation}
    />
  );
}

export default UsersAdminQuickLinks;
